export default "__VITE_ASSET__XLyjcQUY__"